import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import servicePeople from 'services/people';

/**
 * @typedef {Object} UseAddPanelistToPanelMutationVariables
 * @property {number} personId
 * @property {number} panelId
 */

/** @typedef {Omit<UseMutationOptions<any, Error, UseAddPanelistToPanelMutationVariables, unknown>, 'mutationKey' | 'mutationFn'>} UseAddPanelistToPanelMutationOptions */

/**
 * Mutation hook for adding a panelist to a panel.
 *
 * @param {UseAddPanelistToPanelMutationOptions} [options={}]
 */
export const useAddPanelistToPanelMutation = (options = {}) => {
    return useMutation({
        ...options,
        mutationKey: ['add-panelist-to-panel'],
        /** @param {UseAddPanelistToPanelMutationVariables} variables */
        mutationFn: ({ personId, panelId }) => servicePeople.addPanelistToPanel(personId, panelId)
    });
};
